import { render, staticRenderFns } from "./OldVisitAdd.vue?vue&type=template&id=564b22fa&scoped=true"
import script from "./OldVisitAdd.vue?vue&type=script&lang=js"
export * from "./OldVisitAdd.vue?vue&type=script&lang=js"
import style0 from "./OldVisitAdd.vue?vue&type=style&index=0&id=564b22fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564b22fa",
  null
  
)

export default component.exports